export default "__VITE_ASSET__4f69e04a__"